import React, { useState } from 'react'
import styled from 'styled-components'
import { RoughBox, RoughCircle, chalkSquiggleBg } from '../common/Rough'

const Description = styled.div`
    width: 100%;
    font-family: 'Kalam', cursive;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary};
    margin-bottom: 10px;
    @media only screen and (max-width: 768px){
        font-size: 13px;
    }
`

const Span = styled.div`
  overflow: hidden;
  display: -webkit-box;
  max-width: 100%;
  -webkit-line-clamp: ${(p) => (p.$expanded ? 'unset' : 4)};
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
`

const CardOuter = styled.div`
  width: 650px;
  transform: rotate(${(p) => (p.$flip ? '-0.4deg' : '0.4deg')});
  transition: transform 0.3s ease;
  &:hover {
    transform: rotate(0deg);
  }
  @media only screen and (max-width: 768px) {
    width: 100%;
    max-width: 420px;
  }
`;

const ReadMore = styled.button`
  position: relative;
  display: inline-block;
  margin-top: 6px;
  padding: 0;
  border: none;
  background: transparent;
  font-family: 'Kalam', cursive;
  font-weight: 700;
  font-size: 13px;
  color: ${({ theme }) => theme.primary};
  cursor: pointer;

  &::after {
    content: "";
    position: absolute;
    left: -2px;
    right: -2px;
    bottom: 2px;
    height: 10px;
    background-image: ${({ theme }) => chalkSquiggleBg(theme.primary)};
    background-repeat: repeat-x;
    background-size: 40px 10px;
  }
`;

const Top = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 14px
`

const Logo = styled.img`
    width: 26px;
    height: 26px;
    object-fit: contain;
    border-radius: 50%;
`

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`


const Role = styled.div`
    font-family: 'Caveat', cursive;
    font-size: 24px;
    font-weight: 700;
    color: ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 768px){
        font-size: 20px;
    }
`

const Company = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 15px;
    font-weight: 700;
    color: ${({ theme }) => theme.primary};
    @media only screen and (max-width: 768px){
        font-size: 13px;
    }
`

const Date = styled.div`
    font-family: 'Kalam', cursive;
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px){
        font-size: 11px;
    }
`


const Skills = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    margin-top: 4px;
    font-family: 'Kalam', cursive;
`

const ItemWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

const Skill = styled.div`
    font-size: 14px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_primary};
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`



const ExperienceCard = ({ experience, flip }) => {
    const [expanded, setExpanded] = useState(false);
    const hasMore = Array.isArray(experience?.desc) ? experience.desc.length > 2 : false;

    return (
        <CardOuter $flip={flip}>
            <RoughBox roughness={2.2} strokeWidth={1.7} padding="18px 22px" seed={experience.id * 53 + 11}>
                <Top>
                    {experience.img && (
                        <RoughCircle size={38} strokeWidth={1.3} roughness={2.3}>
                            <Logo src={experience.img} />
                        </RoughCircle>
                    )}
                    <Body>
                        <Role>{experience.role}</Role>
                        <Company>{experience.company}</Company>
                        <Date>{experience.date}</Date>
                    </Body>
                </Top>
                <Description>
                    {experience?.desc && (
                        <Span $expanded={expanded}>
                            {Array.isArray(experience.desc) ? (
                                experience.desc.map((bullet, index) => (
                                    <div key={index} style={{ marginBottom: '4px' }}>✎ {bullet}</div>
                                ))
                            ) : (
                                experience.desc
                            )}
                        </Span>
                    )}
                    {hasMore && (
                        <ReadMore onClick={() => setExpanded((e) => !e)}>
                            {expanded ? 'read less ↑' : 'read more ↴'}
                        </ReadMore>
                    )}
                    {experience?.skills &&
                        <>
                            <br />
                            <Skills>
                                <b>Skills:</b>
                                <ItemWrapper>
                                    {experience?.skills?.map((skill, index) => (
                                        <Skill key={index}>• {skill}</Skill>
                                    ))}
                                </ItemWrapper>
                            </Skills>
                        </>
                    }
                </Description>
                {experience.doc &&
                    <a href={experience.doc} target="new">
                        <img src={experience.doc} alt="document" style={{ height: 70, borderRadius: 6 }} />
                    </a>
                }
            </RoughBox>
        </CardOuter>
    )
}

export default ExperienceCard
